import React from 'react';
import clsx from 'clsx';

import { TextTag, Variant } from '../../';

type Props = {
  id?: string;
  className?: string;
  tag?: TextTag;
  size?: keyof typeof Size;
  variant?: keyof typeof Variant;
  children: React.ReactNode;
};

export enum Size {
  regular = 'text-tag',
  small = 'text-tag-small',
}

export const Caption = React.forwardRef<HTMLDivElement, Props>(
  ({ id, className, size = 'regular', variant = 'regular', tag: Tag = 'p', children }, ref) => (
    <Tag
      id={id}
      className={clsx('font-body tracking-widest uppercase', Size[size], Variant[variant], className)}
      ref={ref}
    >
      {children}
    </Tag>
  )
);
